import React, { Component, PropTypes } from 'react';
// import { Link } from 'react-router';
import TabBar from "../../TabBar";

class ImageHome extends Component {
    render() {
        const {params: {id}} = this.props;

        return(
            <div>
                <TabBar
                    items={[
                        {to: `/station/${id}/images/search`, label: 'Search'},
                        {to: `/station/${id}/images/dashboard`, label: 'Dashboard'},
                        {to: `/station/${id}/images/comparison`, label: 'Comparison'},
                        {to: `/station/${id}/images/upload`, label: 'Upload'},
                    ]}
                /><br/>
                {this.props.children}
            </div>
        );
    }
}

export default ImageHome;



// WEBPACK FOOTER //
// ./src/components/Station/Image/index.js